import PageLayout from "../../../components/common/page-layout";
import CreateTestOrderForm from "../../../components/test-orders/create-test-order-form";
import { RequireAuth } from "../../../hooks/use-auth";

/** Route page for creating a test order. */
const TestOrderCreatePage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Create test order">
        <CreateTestOrderForm />
      </PageLayout>
    </RequireAuth>
  );
};

export default TestOrderCreatePage;
